<div>
  <app-google-integration-info [customerId]="customerId"></app-google-integration-info>
  <hr class="mt-0 mb-3" />
  <div class="row">
    <app-components-managecustomer-customeraccountgroup [options]="{
      customerId: customerId,
      customerAccountTypes: customerAccountTypes,
      showSaveButton: showSaveButton,
      isEnabled: isEnabled(),
      publicApiCallback: publicApiCallback
    }"></app-components-managecustomer-customeraccountgroup>
  </div>
</div>